import { useAuth } from "@/contexts/AuthContext";
import { useVendorMode } from "@/contexts/VendorModeContext";
import { Truck, User } from "lucide-react";

/**
 * ModeSelector — shown only for verified vendors on their very first launch
 * after verification. Never shown to non-vendor accounts.
 * Never shown again after first selection — app remembers default.
 */
export default function ModeSelector() {
  const { user } = useAuth();
  const { selectMode } = useVendorMode();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-8 bg-[#1C1C1E]" data-testid="mode-selector">
      {/* App logo */}
      <div className="mb-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center mx-auto mb-3 shadow-lg">
          <span className="text-2xl font-black text-white">BF</span>
        </div>
        <p className="text-white/60 text-sm">Welcome, {user?.first_name || "Vendor"}</p>
      </div>

      {/* Two full-width buttons filling the screen */}
      <div className="flex-1 w-full flex flex-col gap-3 max-w-sm">
        {/* VENDOR MODE button */}
        <button
          onClick={() => selectMode(true)}
          className="flex-1 rounded-2xl bg-[#1C1C1E] border-2 border-[#F59E0B] flex flex-col items-center justify-center gap-3 transition-all hover:bg-[#2C2C2E] active:scale-[0.98] shadow-[0_0_20px_rgba(245,158,11,0.15)]"
          data-testid="select-vendor-mode"
        >
          <div className="w-14 h-14 rounded-full bg-[#F59E0B] flex items-center justify-center">
            <Truck className="w-7 h-7 text-[#1C1C1E]" />
          </div>
          <span className="text-xl font-black text-white tracking-wide">VENDOR MODE</span>
          <span className="text-white/40 text-xs">Manage your truck, go live, track customers</span>
        </button>

        {/* USER MODE button */}
        <button
          onClick={() => selectMode(false)}
          className="flex-1 rounded-2xl bg-sky-500 flex flex-col items-center justify-center gap-3 transition-all hover:bg-sky-600 active:scale-[0.98] shadow-lg"
          data-testid="select-user-mode"
        >
          <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
            <User className="w-7 h-7 text-white" />
          </div>
          <span className="text-xl font-black text-white tracking-wide">USER MODE</span>
          <span className="text-white/60 text-xs">Discover birthday deals near you</span>
        </button>
      </div>

      {/* Small text below */}
      <p className="text-white/30 text-[11px] mt-6" data-testid="mode-switch-hint">You can switch anytime from the menu.</p>
    </div>
  );
}
